import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { locationService } from '../services';
import type { SelectProps } from 'antd';

const { Option } = Select;

interface WardSelectorProps extends Omit<SelectProps, 'options' | 'loading'> {
  value?: string;
  onChange?: (value: string) => void;
  provinceCode?: string;
}

const WardSelector: React.FC<WardSelectorProps> = ({ value, onChange, provinceCode, ...restProps }) => {
  const { data: apiResponse, isLoading } = useQuery({
    queryKey: ['wards', provinceCode],
    queryFn: () => {
      return locationService.getWards(provinceCode || '');
    },
    enabled: !!provinceCode, // Only fetch when provinceCode is provided
  });

  const wards = apiResponse?.data || [];
  console.log('[DEBUG] (👉ﾟヮﾟ)👉  ~ WardSelector  ~ wards:', wards)

  return (
    <Select
      value={value}
      onChange={onChange}
      loading={isLoading}
      placeholder="Chọn phường/xã"
      disabled={!provinceCode}
      {...restProps}
    >
      {wards.map((ward: any) => (
        <Option key={ward.ward_code} value={ward.ward_code}>
          {ward.name}
        </Option>
      ))}
    </Select>
  );
};

export default WardSelector;

